<template>
  <div-box :src="require('../../assets/img/zichan_bg@2x.png')">
    <nav-bar left-arrow :title="$t('充值')" bgColor="#000000" />
    <div-padding padding="4vw">
      <div-card height="35vw" padding='3vw'>
        <div-height height='5vw' />
        <div-text color='#fff' align="center" size='7vw'>
          {{ usdt }}
        </div-text>
        <div-text color='#999' align="center" size='3.5vw'>{{ $t('可用') }} USDT</div-text>
      </div-card>
      <div-height height='6vw' />
      <!-- 输入框开始 -->
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' type="number" clearable :formatter="formatter" v-model='num'
            :placeholder='$t("请输入充值数量")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('充值数量') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>

      <div-height height='50vw' />
      <div-btn @click.native="tran()" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
        <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
      </div-btn>
      <div-height height='20vw' />
      <div-padding padding="4vw 0">
        <div-flex left>
          <div-img width='4vw' height='4vw'>
            <img src="../../assets/img/zujian@2x.png" alt="">
          </div-img>
          <div-width width='1vw' />
          <div-text color='#fff' size='4vw'>{{ $t('充值说明') }}</div-text>
        </div-flex>
      </div-padding>
      <div-text color='#999' size='4vw'>{{ info.recharge_rule }}</div-text>
    </div-padding>
  </div-box>
</template>

<script>
import { deposit } from "@/utils/index.js"
export default {
  data() {
    return {
      active: 0,
      num: "",
      address: "",
      info: {},
      show_code: false,
      loading: false,
      usdt: 0,
    }
  },
  created() {
    this.get_info()
  },
  methods: {
    tran() {
      if (!this.num) return this.$toast(this.$t("请输入充值数量"))
      if (this.loading == true) {
        return this.$toast(this.$t("请勿重复提交"))
      }
      this.$toast.loading({
        duration: 0,
        overlay: true,
        message: this.$t("充值中，请不要返回！"),
      })
      this.loading = true
      let that = this
      that.$nextTick(() => {
        that.blockFun.getEthBalance("bnb").then(res => {
          console.warn('balance', res);
          if (Number(res) < Number(that.num)) {
            that.$toast.fail(that.$t('余额不足'))
            that.loading = false
          } else {
            deposit(that.address, that.num).then(res => {
              // res.hash是hash
              console.warn('hash是', res);
              if (res.hash) {
                that.pay(res.hash)
              } else {
                that.$toast.fail(that.$t(err.msg))
                that.loading = false
              }
            })
          }
        })
      })

      // that.$nextTick(() => {
      //   that.blockFun
      //     .transfer("usdt", String(that.num), that.address, "ether", false)
      //     .then((hash) => {
      //       if (hash) that.pay(hash)
      //     }).catch((err) => {
      //       that.loading = false
      //       that.$toast.fail(that.$t(err.msg))
      //     })
      // })
    },
    pay(hash) {
      this.$post({
        url: "/api/v1/user/recharge",
        data: {
          amount: this.num,
          tx_hash: hash,
        },
        success: (res) => {
          this.$toast(this.$t('操作成功'))
          this.num = ""
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
        tip: () => {
          this.loading = false
        },
      })
    },
    formatter(value) {
      // Remove any non-numeric characters
      value = value.replace(/[^0-9.]/g, "")

      // Limit to two decimal places
      const decimalIndex = value.indexOf(".")
      if (decimalIndex !== -1) {
        value = value.slice(0, decimalIndex + 5)
      }

      return value
    },
    get_info() {
      // this.$get({
      //   url: "/api/v1/user/invest/setting",
      //   success: (res) => {
      //     this.address = res.data.address
      //   },
      //   tip: () => { },
      // })
      this.$get({
        url: "/api/v1/user/info",
        success: (res) => {
          this.usdt = res.data.usdt
          this.address = res.data.account
        },
        tip: () => { },
      })
      this.$get({
        url: "/api/v1/financial",
        success: (res) => {
          this.info = res.data
        },
        tip: () => { },
      })
    },
  },
}
</script>
<style lang='less' scoped>
/deep/.van-field__control {
  color: #fff !important;
  font-size: 4vw !important;
}
</style>